export const menuItems = [
  {
    id: 1,
    rank: 1,
    name: "もみほぐし 90分",
    subtitle: "（肩甲骨はがし付き）",
    description: "全身の疲れを芯からほぐす、当店人気No.1メニュー。肩甲骨周りの固まりを丁寧にほぐし、血流を促進します。",
    price: "¥9,000",
    time: "90分",
    image: "images/menu/01-momihogushi-90.jpg",
  },
  {
    id: 2,
    rank: 2,
    name: "もみほぐし 60分 + ヘッドマッサージ 10分",
    subtitle: "（肩甲骨はがし付き）",
    description: "身体の疲れに加え、頭部のコリも同時にケア。仕事の疲れが気になる方におすすめのセットメニューです。",
    price: "¥7,500",
    time: "70分",
    image: "images/menu/02-momihogushi-head.jpg",
  },
  {
    id: 3,
    rank: 3,
    name: "リンパマッサージ 90分",
    subtitle: "",
    description: "全身のリンパ流れを促進し、老廃物の排出をサポート。むくみや冷えが気になる方に特に効果的です。",
    price: "¥10,000",
    time: "90分",
    image: "images/menu/03-lymph-90.jpg",
  },
  {
    id: 4,
    rank: 4,
    name: "美筋リンパマッサージ 60分",
    subtitle: "",
    description: "筋肉とリンパの両面からアプローチ。ボディラインを整えながら、内側からキレイを目指す方に人気です。",
    price: "¥8,000",
    time: "60分",
    image: "images/menu/04-bisuji-lymph-60.jpg",
  },
  {
    id: 5,
    rank: 5,
    name: "顔ツボ・ベッドマッサージ 30分",
    subtitle: "",
    description: "短時間で効率的にケア。顔のツボ押しとベッド上でのほぐしで、気軽にリフレッシュできます。",
    price: "¥4,000",
    time: "30分",
    image: "images/menu/05-face-bed-30.jpg",
  },
];

export const salonInfo = {
  name: "ほぐし屋さん 〜Luminosite〜",
  nameEn: "Hogushiya Luminosite",
  phone1: "0661367474",
  phone2: "09096985401",
  address: "〒5300041 大阪市北区天神橋4-5-2 エンゼル天満 2階",
  stations: [
    { line: "JR天満駅", walk: "徒歩3分" },
    { line: "地下鉄 扇町駅", walk: "徒歩3分" },
  ],
  hours: "11時〜22時（最終受付21時）",
  holiday: "不定休",
  beds: 3,
  hotpepperUrl: "https://beauty.hotpepper.jp/kr/slnH000546789/",
};

export const facilities = [
  {
    icon: "ri-hotel-bed-line",
    title: "完全個室",
    description: "ベッド数3台の完全個室で、他のお客様を気にせず、心ゆくまでリラックスしていただけます。",
  },
  {
    icon: "ri-heart-pulse-line",
    title: "熟練の技術",
    description: "肩甲骨はがしを得意とした施術者が、一人ひとりの状態に合わせたオーダーメイドケアを提供します。",
  },
  {
    icon: "ri-leaf-line",
    title: "落ち着いた空間",
    description: "緑と茶色を基調とした温かみのあるインテリア。都会の喧騒を忘れられる、静かな隠れ家サロンです。",
  },
  {
    icon: "ri-time-line",
    title: "柔軟な営業時間",
    description: "11時〜22時まで営業（最終受付21時）。お仕事帰りやお買い物のついでにも気軽にご利用いただけます。",
  },
];